import React, { FC, useEffect, useState } from 'react';
import TextInput from '../text/TextInput';

export interface Props {
  id?: string;
  enabled?: boolean;
  placeholder?: string;
  value: string | undefined;
  touched?: boolean;
  error?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  size?: 'sm' | 'lg';
  rest?: Record<string, unknown>;
  style?: React.CSSProperties;
  onReset?: () => void;
  readOnlyMode?: boolean;
}

const CurrencyInput: FC<Props> = ({
  id,
  value,
  touched,
  error,
  enabled = true,
  placeholder,
  onChange,
  onBlur,
  size,
  rest,
  style,
  onReset,
  readOnlyMode,
}: Props) => {
  const [input, setInput] = useState('');
  useEffect(() => {
    if (value) {
      setInput(value);
    }
  }, [value]);
  return (
    <TextInput
      id={id}
      value={input}
      touched={touched}
      error={error}
      enabled={enabled}
      placeholder={placeholder}
      onChange={(e) => {
        e.target.value = e.target.value.replace(/[^0-9\.]/g, '');
        if (onChange) {
          onChange(e);
        }
        setInput(e.target.value);
      }}
      onBlur={(e) => {
        // Remove all . but last
        const value = e.target.value.replace(/\.(?=[^.]*\.)/g, '');
        let splittedValue = value.split('.');

        if (splittedValue.length == 1) {
          e.target.value = splittedValue[0] + '.00';
        } else if (splittedValue.length > 1) {
          const { 0: first, [splittedValue.length - 1]: last } = splittedValue;
          splittedValue = [first, last];
          e.target.value = `${first}.${last}`;
          if (splittedValue[1].length == 0) {
            e.target.value += '00';
          } else if (splittedValue[1].length == 1) {
            e.target.value += '0';
          } else if (splittedValue[1].length > 2) {
            e.target.value = Number(e.target.value).toFixed(2);
          }
        }
        if (onChange) {
          onChange(e);
        }
        if (onBlur) {
          onBlur(e);
        }
        setInput(e.target.value);
      }}
      size={size}
      rest={rest}
      style={style}
      onReset={onReset}
      readOnlyMode={readOnlyMode}
    ></TextInput>
  );
};

export default CurrencyInput;
